import React from "react";
import { Navigate, Route, RouteProps } from "react-router-dom";

// components
import PrivateRoute from "./PrivateRoute";

import News from "../pages/forms/News";

import FooterSection from "../pages/forms/Footer";

import Employee from "../pages/Employees/Employees";
import LatestInformation from "../pages/forms/LatestInformation";
import InternationalSportingEvents from "../pages/forms/InternationalSportingEvent";

import HeadLink from "../pages/other/HeadLink";

import Departments from "../pages/forms/Departments";

//  ----------------------------------Faculties  Starts ----------------------------------
import FacultyOfMedicine from "../pages/Departments/FacultyOfMedicine";
import FacultyOfNursing from "../pages/Departments/FacultyOfNursing";
import FacultyOfPharmacy from "../pages/Departments/FacultyOfPharmacy";
import FacultyOfParamedicalScience from "../pages/Departments/FacultyOfParamedicalScience";
import FacultyOfDentalSciences from "../pages/Departments/FacultyOfDentalSciences";
import SchoolRequestsPage from "../pages/dashboard/schooldashboard/SchoolRequestsPage/SchoolRequestsPage";
//  ----------------------------------Faculties Ends ----------------------------------

// -----------------------------------Start Admin Routes Student Management System-------------------------------------
import UgRegistration from "../pages/admindashboard/UgRegistration";
import MbbsStudentList from "../pages/mbbs-student-list/MbbsStudentList";
import NursingStudentList from "../pages/nursing-student-list/NursingStudentList";
import MbbsElectives from "../pages/mbbs-Electives/MbbsElectives";

// -------------------Attendance Module start-------------------------------
import UGAttendance from "../pages/attendance/UGAttendance";
import PGAttendance from "../pages/attendance/PGAttendance";
import BatteryTest from "../pages/dashboard/BatteryTest";
import ProfileRegisterStudent from "../pages/dashboard/schooldashboard/studentProfile/ProfileRegisterStudent";
// ----------------------Attendance Module End-----------
const AdminProfile = React.lazy(
  () => import("../pages/admindashboard/AdminProfile")
);
const AddSession = React.lazy(
  () => import("../pages/admindashboard/AddSession")
);

const AddCourses = React.lazy(
  () => import("../pages/admindashboard/AddCourses")
);

const AddExamination = React.lazy(
  () => import("../pages/admindashboard/AddExamination")
);

const AddSubject = React.lazy(
  () => import("../pages/admindashboard/AddSubject")
);

// ------------------------------------End Admin Routes Student Management System-------------------------------

// auth
const Login = React.lazy(() => import("../pages/auth/Login"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));
const Confirm = React.lazy(() => import("../pages/auth/Confirm"));
const ForgetPassword = React.lazy(() => import("../pages/auth/ForgetPassword"));
const Register = React.lazy(() => import("../pages/auth/Register"));
const LockScreen = React.lazy(() => import("../pages/auth/LockScreen"));
const ForgotPasswordLink = React.lazy(
  () => import("../pages/auth/ForgotPasswordLink")
);

// auth for Student login
const StudentLogin = React.lazy(() => import("../pages/auth/StudentLogin"));

// landing
const Landing = React.lazy(() => import("../pages/landing"));
// const HelpDesk = React.lazy(() => import("../pages/landing/Helpdesk"));
const HelpDesk = React.lazy(() => import("../pages/landing/Helpdesk"));
const Mbbsdesc = React.lazy(() => import("../pages/landing/mbbs"));
const CRCList = React.lazy(() => import("../pages/landing/CRCList"));
const CoordinatorTrainer = React.lazy(
  () => import("../pages/landing/CoordinatorTrainer")
);

// Student Profile
const DummyStudentProfile = React.lazy(
  () => import("../pages/other/Profile/index")
);

// View Attendance
const ViewAttendance = React.lazy(() => import("../pages/tables/Advanced"));

const AttendaceSheet = React.lazy(
  () => import("../pages/other/Profile/OtherDetails/attendance")
);

// --------------------------------- different pags routing -----------

// const OurPolicy = React.lazy(() => import("../pages/other/OurPolicy"));

const DsoDirectory = React.lazy(() => import("../pages/other/DsoDirectory"));

// ---------------------------------- dashboard ----------------------------------
const EcommerceDashboard = React.lazy(
  () => import("../pages/dashboard/Ecommerce/attandance")
);

const EcommerceDashboard1 = React.lazy(
  () => import("../pages/dashboard/Ecommerce/attandance")
);
const EcommerceDashboard2 = React.lazy(
  () => import("../pages/dashboard/Ecommerce/attandance2")
);

const AnalyticsDashboard = React.lazy(
  () => import("../pages/dashboard/Analytics")
);
const AnalyticsDashboardPG = React.lazy(
  () => import("../pages/dashboard/AnalyticsPG")
);

// -----------------------------------------Start Student dashboard Routes---------------------

// const StudentDashboard = React.lazy(
//   () => import("../pages/dashboard/studentdashboard")
// );

const SchoolProfile = React.lazy(
  () => import("../pages/dashboard/schooldashboard/schoolProfile")
);

// CRC-level stat-card/chart dashboard, additional to (not replacing)
// SchoolProfile above - see crcDashboard/index.tsx for why it's a separate
// page/route.
const CrcDashboard = React.lazy(
  () => import("../pages/dashboard/schooldashboard/crcDashboard")
);

const StudentProfile = React.lazy(
  () => import("../pages/dashboard/studentdashboard/ugdashboard/StudentProfile")
);

const RegisterStudent = React.lazy(
  () => import("../pages/dashboard/schooldashboard/RegisterStudent")
);

const IntraSchoolTeam = React.lazy(
  () => import("../pages/dashboard/schooldashboard/team/intrateam")
);

const IntraSchoolTeamDetails = React.lazy(
  () => import("../pages/dashboard/schooldashboard/team/intrateam/TeamDetails")
);

const ResultAndReward = React.lazy(
  () => import("../pages/dashboard/schooldashboard/resultAward/ResultAndReward")
);

const TeamResult = React.lazy(
  () => import("../pages/dashboard/schooldashboard/resultAward/TeamResult")
);

// Unified replacement for ResultAndReward/TeamResult - both routes below now
// point here. The two originals are kept, unused, as an easy revert path.
const UpdateRank = React.lazy(
  () => import("../pages/dashboard/schooldashboard/resultAward/UpdateRank")
);

const SchoolTeam = React.lazy(
  () => import("../pages/dashboard/schooldashboard/team/schoolteam")
);

const SchoolTeamToBloak = React.lazy(
  () => import("../pages/dashboard/schooldashboard/finalSchoolTeam/schoolTeam")
);

const SchoolTeamDetails = React.lazy(
  () =>
    import(
      "../pages/dashboard/schooldashboard/team/schoolteam/SchoolTeamDetails"
    )
);

const SchoolPlayers = React.lazy(
  () => import("../pages/dashboard/schooldashboard/schoolPlayers/index")
);

// New "Students" menu - reuses the same allPlayer data as SchoolPlayers
// above (View CRC Players), re-skinned per today's dev-plan entry.
const StudentsPage = React.lazy(
  () => import("../pages/dashboard/schooldashboard/StudentsPage/StudentsPage")
);

const TeamsPage = React.lazy(
  () => import("../pages/dashboard/schooldashboard/TeamsPage/TeamsPage")
);

const DownloadAttendanceCard = React.lazy(
  () =>
    import(
      "../pages/dashboard/studentdashboard/ugdashboard/attendance/Attendance"
    )
);

const HomeDashboard = React.lazy(
  () => import("../pages/dashboard/Home/HeaderTwo")
);

// -----------------------------------------District-level routes---------------------
const DistrictSchoolProfile = React.lazy(
  () => import("../pages/dashboard/districtdashboard/districtSchoolProfile")
);
// District-level stat-card/chart dashboard (same task as CrcDashboard/
// BlockDashboard) - additional to, not a replacement for,
// DistrictSchoolProfile above.
const DistrictDashboard = React.lazy(
  () => import("../pages/dashboard/districtdashboard/districtDashboard")
);
const DistrictSchoolPlayers = React.lazy(
  () => import("../pages/dashboard/districtdashboard/districtSchoolPlayers")
);
const DistrictStudentsPage = React.lazy(
  () => import("../pages/dashboard/districtdashboard/StudentsPage/StudentsPage")
);
const DistrictTeamsPage = React.lazy(
  () => import("../pages/dashboard/districtdashboard/TeamsPage/TeamsPage")
);
const DistrictResultAndReward = React.lazy(
  () => import("../pages/dashboard/districtdashboard/districtResultAward/ResultAndReward")
);
const DistrictTeamResult = React.lazy(
  () => import("../pages/dashboard/districtdashboard/districtResultAward/TeamResult")
);
// Unified replacement for DistrictResultAndReward/DistrictTeamResult, same
// approach as Cluster's UpdateRank.tsx. The two originals are kept, unused,
// as an easy revert path.
const DistrictUpdateRank = React.lazy(
  () => import("../pages/dashboard/districtdashboard/districtResultAward/UpdateRank")
);
const DistrictSchoolTeam = React.lazy(
  () => import("../pages/dashboard/districtdashboard/team/schoolteam")
);
const DistrictSchoolTeamDetails = React.lazy(
  () => import("../pages/dashboard/districtdashboard/team/schoolteam/SchoolTeamDetails")
);
const DistrictIntraSchoolTeam = React.lazy(
  () => import("../pages/dashboard/districtdashboard/team/intrateam")
);
const DistrictIntraSchoolTeamDetails = React.lazy(
  () => import("../pages/dashboard/districtdashboard/team/intrateam/TeamDetails")
);
const DistrictTransferToState = React.lazy(
  () => import("../pages/dashboard/districtdashboard/finalDistrictTeam/schoolTeam")
);
const DistrictRegisterStudent = React.lazy(
  () => import("../pages/dashboard/districtdashboard/RegisterStudent")
);
const DistrictProfileRegisterStudent = React.lazy(
  () => import("../pages/dashboard/districtdashboard/districtStudentProfile/ProfileRegisterStudent")
);

// -----------------------------------------Block-level routes---------------------
const BlockSchoolProfile = React.lazy(
  () => import("../pages/dashboard/blockdashboard/schoolProfile")
);
// Block-level stat-card/chart dashboard (Task 5, 15 Sept dev-plan) -
// additional to, not a replacement for, BlockSchoolProfile above - see
// blockDashboard/index.tsx for why (mirrors how CrcDashboard was introduced
// alongside SchoolProfile before the CRC Profile page was later hidden).
const BlockDashboard = React.lazy(
  () => import("../pages/dashboard/blockdashboard/blockDashboard")
);
const BlockSchoolPlayers = React.lazy(
  () => import("../pages/dashboard/blockdashboard/schoolPlayers")
);
const BlockStudentsPage = React.lazy(
  () => import("../pages/dashboard/blockdashboard/StudentsPage/StudentsPage")
);
const BlockTeamsPage = React.lazy(
  () => import("../pages/dashboard/blockdashboard/TeamsPage/TeamsPage")
);
const BlockResultAndReward = React.lazy(
  () => import("../pages/dashboard/blockdashboard/resultAward/ResultAndReward")
);
const BlockTeamResult = React.lazy(
  () => import("../pages/dashboard/blockdashboard/resultAward/TeamResult")
);
// Unified replacement for BlockResultAndReward/BlockTeamResult, same
// approach as Cluster's UpdateRank.tsx. The two originals are kept, unused,
// as an easy revert path.
const BlockUpdateRank = React.lazy(
  () => import("../pages/dashboard/blockdashboard/resultAward/UpdateRank")
);
const BlockSchoolTeam = React.lazy(
  () => import("../pages/dashboard/blockdashboard/team/schoolteam")
);
const BlockSchoolTeamDetails = React.lazy(
  () => import("../pages/dashboard/blockdashboard/team/schoolteam/SchoolTeamDetails")
);
const BlockIntraSchoolTeam = React.lazy(
  () => import("../pages/dashboard/blockdashboard/team/intrateam")
);
const BlockIntraSchoolTeamDetails = React.lazy(
  () => import("../pages/dashboard/blockdashboard/team/intrateam/TeamDetails")
);
const BlockTransferToDistrict = React.lazy(
  () => import("../pages/dashboard/blockdashboard/finalSchoolTeam/schoolTeam")
);
const BlockRegisterStudent = React.lazy(
  () => import("../pages/dashboard/blockdashboard/RegisterStudent")
);
const BlockProfileRegisterStudent = React.lazy(
  () => import("../pages/dashboard/blockdashboard/studentProfile/ProfileRegisterStudent")
);
const BlockBatteryTest = React.lazy(
  () => import("../pages/dashboard/BatteryTest")
);

// -----------------------------------------State-level routes---------------------
const StateOverview = React.lazy(
  () => import("../pages/dashboard/statedashboard/StateOverview")
);
const StateSchoolProfile = React.lazy(
  () => import("../pages/dashboard/statedashboard/districtSchoolProfile")
);
// State-level stat-card/chart dashboard (same task as CrcDashboard/
// BlockDashboard/DistrictDashboard) - additional to, not a replacement for,
// StateSchoolProfile above.
const StateDashboard = React.lazy(
  () => import("../pages/dashboard/statedashboard/stateDashboard")
);
const StateSchoolPlayers = React.lazy(
  () => import("../pages/dashboard/statedashboard/districtSchoolPlayers")
);
const StateStudentsPage = React.lazy(
  () => import("../pages/dashboard/statedashboard/StudentsPage/StudentsPage")
);
const StateTeamsPage = React.lazy(
  () => import("../pages/dashboard/statedashboard/TeamsPage/TeamsPage")
);
const StateResultAndReward = React.lazy(
  () => import("../pages/dashboard/statedashboard/districtResultAward/ResultAndReward")
);
const StateTeamResult = React.lazy(
  () => import("../pages/dashboard/statedashboard/districtResultAward/TeamResult")
);
// Unified replacement for StateResultAndReward/StateTeamResult, same
// approach as Cluster's UpdateRank.tsx. The two originals are kept, unused,
// as an easy revert path.
const StateUpdateRank = React.lazy(
  () => import("../pages/dashboard/statedashboard/districtResultAward/UpdateRank")
);
const StateSchoolTeam = React.lazy(
  () => import("../pages/dashboard/statedashboard/team/schoolteam")
);
const StateSchoolTeamDetails = React.lazy(
  () => import("../pages/dashboard/statedashboard/team/schoolteam/SchoolTeamDetails")
);
const StateIntraSchoolTeam = React.lazy(
  () => import("../pages/dashboard/statedashboard/team/intrateam")
);
const StateIntraSchoolTeamDetails = React.lazy(
  () => import("../pages/dashboard/statedashboard/team/intrateam/TeamDetails")
);
const StateRegisterStudent = React.lazy(
  () => import("../pages/dashboard/statedashboard/RegisterStudent")
);
const StateProfileRegisterStudent = React.lazy(
  () => import("../pages/dashboard/statedashboard/districtStudentProfile/ProfileRegisterStudent")
);
const StateWinnerShowcase = React.lazy(
  () => import("../pages/dashboard/statedashboard/WinnerShowcase/WinnerShowcase")
);

//------------------------------------- apps  -----------------------------------
const CalendarApp = React.lazy(() => import("../pages/apps/Calendar"));
const Projects = React.lazy(() => import("../pages/apps/Projects"));
const ProjectDetail = React.lazy(() => import("../pages/apps/Projects/Detail"));
// ----------------------------------------- chat  ---------------------------------
const ChatApp = React.lazy(() => import("../pages/apps/Chat"));
// - email
const Inbox = React.lazy(() => import("../pages/apps/Email/Inbox"));
const EmailDetail = React.lazy(() => import("../pages/apps/Email/Detail"));
const EmailCompose = React.lazy(() => import("../pages/apps/Email/Compose"));
// - tasks
const TaskList = React.lazy(() => import("../pages/apps/Tasks/List"));
const Kanban = React.lazy(() => import("../pages/apps/Tasks/Board"));
// - file
const FileManager = React.lazy(() => import("../pages/apps/FileManager"));

// extra pages
const Error404 = React.lazy(() => import("../pages/error/Error404"));
const Error500 = React.lazy(() => import("../pages/error/Error500"));
// -other
const Starter = React.lazy(() => import("../pages/other/Starter"));
const Profile = React.lazy(() => import("../pages/other/Profile"));
const Activity = React.lazy(() => import("../pages/other/Activity"));
const Invoice = React.lazy(() => import("../pages/other/Invoice"));
const Maintenance = React.lazy(() => import("../pages/other/Maintenance"));
const Pricing = React.lazy(() => import("../pages/other/Pricing"));

// ---------------------------------------- Pages ------------------------
const Gallery = React.lazy(() => import("../pages/forms/Gallery"));

// uikit
const UIElements = React.lazy(() => import("../pages/uikit"));

// widgets
const Widgets = React.lazy(() => import("../pages/widgets"));

// icons
const Unicons = React.lazy(() => import("../pages/icons/Unicons"));
const FeatherIcons = React.lazy(() => import("../pages/icons/Feather"));
const BootstrapIcon = React.lazy(() => import("../pages/icons/Bootstrap"));

// forms
const BasicForms = React.lazy(() => import("../pages/forms/Basic"));
const FormAdvanced = React.lazy(() => import("../pages/forms/Advanced"));
const FormValidation = React.lazy(() => import("../pages/forms/Validation"));
const FormWizard = React.lazy(() => import("../pages/forms/Wizard"));
const FileUpload = React.lazy(() => import("../pages/forms/FileUpload"));
const Editors = React.lazy(() => import("../pages/forms/Editors"));

//-------------------------------------------  inside home   -----------------
const Header = React.lazy(() => import("../pages/forms/Header"));
const Marquees = React.lazy(() => import("../pages/forms/Marquees"));
const Risingstar = React.lazy(() => import("../pages/forms/RisingStarBihar"));

const Events = React.lazy(() => import("../pages/forms/Events"));
const Banner = React.lazy(() => import("../pages/forms/Banner"));
// const Menubar = React.lazy(()=> import ('../pages/forms/Menubar'))
const Achievement = React.lazy(() => import("../pages/forms/Achievement"));

// charts
const Charts = React.lazy(() => import("../pages/charts"));

// tables
const BasicTables = React.lazy(() => import("../pages/tables/Basic"));
const AdvancedTables = React.lazy(() => import("../pages/tables/Advanced"));

// maps
const GoogleMaps = React.lazy(() => import("../pages/maps/GoogleMaps"));

export interface RoutesProps {
  path: RouteProps["path"];
  name?: string;
  element?: RouteProps["element"];
  route?: any;
  exact?: boolean;
  icon?: string;
  header?: string;
  roles?: string[];
  children?: RoutesProps[];
}

// ------------------------------------dashboards --------------------------------
const dashboardRoutes: RoutesProps = {
  path: "/dashboard",
  name: "Dashboards",
  icon: "airplay",
  header: "Navigation",
  children: [
    {
      path: "/",
      name: "Root",
      // element: <Navigate to="/dashboard/ecommerce" />,
      element: <Navigate to="/dashboard/analytics" />,
      route: PrivateRoute,
    },

    // // NewDashboard
    {
      path: "/dashboard/ecommerce",
      name: "Ecommerce",
      element: <EcommerceDashboard />,
      route: PrivateRoute,
    },

    // {
    //   path: "/dashboard/attandance",
    //   name: "Ecommerce",
    //   element: <EcommerceDashboard1 />,
    //   route: PrivateRoute,
    // },
    {
      path: "/dashboard/analytics",
      name: "Analytics",
      element: <AnalyticsDashboard />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard/analyticspg",
      name: "Analytics PG",
      element: <AnalyticsDashboardPG />,
      route: PrivateRoute,
    },
    // {
    //   path: "/",
    //   name: "Root",
    //   element: <Navigate to="/dashboard" />,
    //   route: PrivateRoute,
    // },

    // Student default dashboard

    {
      path: "/dashboard/student-profile",
      name: "Profile",
      element: <StudentProfile />,
      route: PrivateRoute,
    },

    {
      path: "/pages/register-student",
      name: "Register Student",
      element: <RegisterStudent />,
      route: PrivateRoute,
    },
    {
      path: "/pages/student-profile/:studentId",
      name: "View Student Profile",
      element: <ProfileRegisterStudent />,
      route: PrivateRoute,
    },

    {
      path: "/dashboard/school",
      name: "Student Dashboard",
      // element: <StudentDashboard />,
      element: <SchoolProfile />,
      route: PrivateRoute,
    },
    {
      path: "/pages/battery-test",
      name: "BatteryTest",
      element: <BatteryTest />,
      route: PrivateRoute,
    },
    {
      path: "/pages/create-intra-school-team",
      name: "intraschoolteam",
      element: <IntraSchoolTeam />,
      route: PrivateRoute,
    },

    {
      path: "/pages/team/:teamId",
      name: "intraschool-teamdetails",
      element: <IntraSchoolTeamDetails />,
      route: PrivateRoute,
    },

    {
      path: "/pages/send-final-players-to-crc",
      name: "Transfer to Block",
      element: <SchoolTeamToBloak />,
      route: PrivateRoute,
    },

    {
      path: "/pages/create-crc-team",
      name: "schoolteams",
      element: <SchoolTeam />,
      route: PrivateRoute,
    },
    {
      path: "/pages/school-team/:teamId",
      name: "school-teamdetails",
      element: <SchoolTeamDetails />,
      route: PrivateRoute,
    },
    {
      path: "/pages/view-crc-players",
      name: "view-school-players",
      element: <SchoolPlayers />,
      route: PrivateRoute,
    },

    {
      path: "/pages/students",
      name: "students",
      element: <StudentsPage />,
      route: PrivateRoute,
    },

    {
      path: "/pages/teams",
      name: "teams",
      element: <TeamsPage />,
      route: PrivateRoute,
    },

    // Block level routes
    {
      path: "/dashboard/crc",
      name: "Student Dashboard",
      element: <SchoolProfile />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard/crc-stats",
      name: "CRC Dashboard",
      element: <CrcDashboard />,
      route: PrivateRoute,
    },

     {
      path: "pages/pullrequestlist",
      name: "Student Dashboard",
      element: <SchoolRequestsPage />,
      route: PrivateRoute,
    },

    // Kept pointing at their original components, unlinked from the sidebar
    // (see studentPanelMenu.ts) rather than removed - old direct links still
    // work. The new merged "Update Rank" menu item points at the new route
    // below instead.
    {
      path: "/pages/result-and-rewards",
      name: "resultrewards",
      element: <ResultAndReward />,
      route: PrivateRoute,
    },

    {
      path: "/pages/team-result-entry",
      name: "teamresult",
      element: <TeamResult />,
      route: PrivateRoute,
    },

    {
      path: "/pages/update-rank",
      name: "update-rank",
      element: <UpdateRank />,
      route: PrivateRoute,
    },

    // Same UpdateRank page as above, reachable at the URL the school app
    // (bssa-school-games-frontend) uses for its own equivalent unified
    // rank/reward page, so the path is consistent across apps.
    {
      path: "/pages/result-and-rank",
      name: "result-and-rank",
      element: <UpdateRank />,
      route: PrivateRoute,
    },
  ],
};

// ------------------------------------District-level dashboard routes--------------------------------
// Ported from districtdashboard.biharsportsmashaal.in. Paths are namespaced under
// /pages/district/* since several (e.g. create-team, view-players) would otherwise
// collide with this app's own cluster-level routes above.
const districtRoutes: RoutesProps = {
  path: "/dashboard/district",
  name: "District Dashboard",
  children: [
    {
      path: "/dashboard/district",
      name: "District Profile",
      element: <DistrictSchoolProfile />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard/district-stats",
      name: "District Dashboard",
      element: <DistrictDashboard />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/view-players",
      name: "View District Players",
      element: <DistrictSchoolPlayers />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/students",
      name: "District Player Registration",
      element: <DistrictStudentsPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/teams",
      name: "District Transferred Teams",
      element: <DistrictTeamsPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/result-and-rewards",
      name: "District Result Entry",
      element: <DistrictResultAndReward />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/team-result-entry",
      name: "District Team Result Entry",
      element: <DistrictTeamResult />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/result",
      name: "District Result",
      element: <DistrictUpdateRank />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/create-team",
      name: "Create District Team",
      element: <DistrictSchoolTeam />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/school-team/:teamId",
      name: "District Team Details",
      element: <DistrictSchoolTeamDetails />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/create-intra-team",
      name: "Create Intra-School Team (District)",
      element: <DistrictIntraSchoolTeam />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/team/:teamId",
      name: "Intra-School Team Details (District)",
      element: <DistrictIntraSchoolTeamDetails />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/transfer-to-state",
      name: "Transfer to State",
      element: <DistrictTransferToState />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/register-student",
      name: "Register Student (District)",
      element: <DistrictRegisterStudent />,
      route: PrivateRoute,
    },
    {
      path: "/pages/district/student-profile/:studentId",
      name: "View Student Profile (District)",
      element: <DistrictProfileRegisterStudent />,
      route: PrivateRoute,
    },
  ],
};

// ------------------------------------Block-level dashboard routes--------------------------------
// Ported from block.biharsportsmashaal.in. Paths namespaced under /pages/block/*
// for the same reason as District above.
const blockRoutes: RoutesProps = {
  path: "/dashboard/block",
  name: "Block Dashboard",
  children: [
    {
      path: "/dashboard/block",
      name: "Block Profile",
      element: <BlockSchoolProfile />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard/block-stats",
      name: "Block Dashboard",
      element: <BlockDashboard />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/view-players",
      name: "View Block Players",
      element: <BlockSchoolPlayers />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/students",
      name: "Block Player Registration",
      element: <BlockStudentsPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/teams",
      name: "Block Transferred Teams",
      element: <BlockTeamsPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/result-and-rewards",
      name: "Block Result Entry",
      element: <BlockResultAndReward />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/team-result-entry",
      name: "Block Team Result Entry",
      element: <BlockTeamResult />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/result",
      name: "Block Result",
      element: <BlockUpdateRank />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/create-team",
      name: "Create Block Team",
      element: <BlockSchoolTeam />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/school-team/:teamId",
      name: "Block Team Details",
      element: <BlockSchoolTeamDetails />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/create-intra-team",
      name: "Create Intra-School Team (Block)",
      element: <BlockIntraSchoolTeam />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/team/:teamId",
      name: "Intra-School Team Details (Block)",
      element: <BlockIntraSchoolTeamDetails />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/transfer-to-district",
      name: "Transfer to District",
      element: <BlockTransferToDistrict />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/register-student",
      name: "Register Student (Block)",
      element: <BlockRegisterStudent />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/student-profile/:studentId",
      name: "View Student Profile (Block)",
      element: <BlockProfileRegisterStudent />,
      route: PrivateRoute,
    },
    {
      path: "/pages/block/battery-test",
      name: "Battery Test (Block)",
      element: <BlockBatteryTest />,
      route: PrivateRoute,
    },
  ],
};

// ------------------------------------State-level dashboard routes--------------------------------
// Ported from statedashboard.biharsportsmashaal.in (itself a fork of the District
// tree pointed at /api/v3/state/* — see the merge review). Paths namespaced under
// /pages/state/*.
const stateRoutes: RoutesProps = {
  path: "/dashboard/state",
  name: "State Dashboard",
  children: [
    {
      path: "/dashboard/state",
      name: "State Overview",
      element: <StateOverview />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/schools",
      name: "State Schools",
      element: <StateSchoolProfile />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard/state-stats",
      name: "State Dashboard",
      element: <StateDashboard />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/view-players",
      name: "View State Players",
      element: <StateSchoolPlayers />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/students",
      name: "State Player Registration",
      element: <StateStudentsPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/teams",
      name: "State Transferred Teams",
      element: <StateTeamsPage />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/result-and-rewards",
      name: "State Result Entry",
      element: <StateResultAndReward />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/team-result-entry",
      name: "State Team Result Entry",
      element: <StateTeamResult />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/result",
      name: "State Result",
      element: <StateUpdateRank />,
      route: PrivateRoute,
    },
    // {
    //   path: "/pages/state/create-team",
    //   name: "Create State Team",
    //   element: <StateSchoolTeam />,
    //   route: PrivateRoute,
    // },
    {
      path: "/pages/state/school-team/:teamId",
      name: "State Team Details",
      element: <StateSchoolTeamDetails />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/create-intra-team",
      name: "Create Intra-School Team (State)",
      element: <StateIntraSchoolTeam />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/team/:teamId",
      name: "Intra-School Team Details (State)",
      element: <StateIntraSchoolTeamDetails />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/register-student",
      name: "Register Student (State)",
      element: <StateRegisterStudent />,
      route: PrivateRoute,
    },
    {
      path: "/pages/state/student-profile/:studentId",
      name: "View Student Profile (State)",
      element: <StateProfileRegisterStudent />,
      route: PrivateRoute,
    },
    {
      path: "/state-winners",
      name: "State Winner Showcase",
      element: <StateWinnerShowcase />,
      route: PrivateRoute,
    },
  ],
};

const calendarAppRoutes: RoutesProps = {
  path: "/apps/calendar",
  name: "Calendar",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "calendar",
  element: <CalendarApp />,
  header: "Apps",
};

const chatAppRoutes: RoutesProps = {
  path: "/apps/chat",
  name: "Chat",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ChatApp />,
};

const emailAppRoutes: RoutesProps = {
  path: "/apps/email",
  name: "Email",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "mail",
  children: [
    {
      path: "/apps/email/inbox",
      name: "Inbox",
      element: <Inbox />,
      route: PrivateRoute,
    },
    {
      path: "/apps/email/details",
      name: "Email Details",
      element: <EmailDetail />,
      route: PrivateRoute,
    },
    {
      path: "/apps/email/compose",
      name: "Compose Email",
      element: <EmailCompose />,
      route: PrivateRoute,
    },
  ],
};

const projectAppRoutes: RoutesProps = {
  path: "/apps/projects",
  name: "Projects",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "uil-briefcase",

  children: [
    {
      path: "/apps/projects/list",
      name: "List",
      element: <Projects />,
      route: PrivateRoute,
    },
    {
      path: "/apps/projects/details",
      name: "Detail",
      element: <ProjectDetail />,
      route: PrivateRoute,
    },
  ],
};

const taskAppRoutes: RoutesProps = {
  path: "/apps/tasks",
  name: "Tasks",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "clipboard",
  children: [
    {
      path: "/apps/tasks/list",
      name: "Task List",
      element: <TaskList />,
      route: PrivateRoute,
    },

    {
      path: "/apps/tasks/kanban",
      name: "Kanban",
      element: <Kanban />,
      route: PrivateRoute,
    },
  ],
};

const fileAppRoutes: RoutesProps = {
  path: "/apps/file-manager",
  name: "File Manager",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "folder-plus",
  element: <FileManager />,
};

const appRoutes = [
  calendarAppRoutes,
  chatAppRoutes,
  emailAppRoutes,
  projectAppRoutes,
  taskAppRoutes,
  fileAppRoutes,
];

// pages
const extrapagesRoutes: RoutesProps = {
  // ------------------------------- Pages section --------------------

  path: "/pages",
  name: "Pages",
  icon: "package",
  header: "Custom",
  children: [
    // Start Student management system routes

    // Start Student dashboard routes

    // {
    //   path: "/pages/student-profile",
    //   name: "Student Profile",
    //   element: <StudentProfile />,
    //   route: PrivateRoute,
    // },

    {
      path: "/pages/dashboard/download-attendance-card",
      name: "download-attendance-card",
      element: <DownloadAttendanceCard />,
      route: PrivateRoute,
    },

    // End Student dashboard routes

    {
      path: "/pages/admin-profile",
      name: "Profile",
      element: <AdminProfile />,
      route: PrivateRoute,
    },
    {
      path: "/pages/add-session",
      name: "Add Session",
      element: <AddSession />,
      route: PrivateRoute,
    },

    {
      path: "/pages/add-courses",
      name: "Add Courses",
      element: <AddCourses />,
      route: PrivateRoute,
    },

    {
      path: "/pages/add-examination",
      name: "Add Examination",
      element: <AddExamination />,
      route: PrivateRoute,
    },
    {
      path: "/pages/add-subject",
      name: "Add Subject",
      element: <AddSubject />,
      route: PrivateRoute,
    },
    // End Student management system routes

    // {
    //   path: "/pages/starter",
    //   name: "Starter",
    //   element: <Starter />,
    //   route: PrivateRoute,
    // },

    {
      path: "/forms/gallery",
      name: "Gallery",
      element: <Gallery />,
      route: PrivateRoute,
    },

    {
      path: "/pages/dso-directory",
      name: "DSO Directory",
      element: <DsoDirectory />,
      route: PrivateRoute,
    },
  ],
};

// ui
const uiRoutes: RoutesProps = {
  path: "/components",
  name: "Components",
  icon: "package",
  header: "UI Elements",
  children: [
    {
      path: "/components/ui-elements",
      name: "UIElements",
      element: <UIElements />,
      route: PrivateRoute,
    },
    {
      path: "/components/widgets",
      name: "Widgets",
      element: <Widgets />,
      route: PrivateRoute,
    },
    {
      path: "/icons",
      name: "Icons",
      children: [
        {
          path: "/icons/unicons",
          name: "Unicons",
          element: <Unicons />,
          route: PrivateRoute,
        },
        {
          path: "/icons/feather",
          name: "Feather",
          element: <FeatherIcons />,
          route: PrivateRoute,
        },
        {
          path: "/icons/bootstrap",
          name: "Bootstrap Icon",
          element: <BootstrapIcon />,
          route: PrivateRoute,
        },
      ],
    },

    // ---------------------------------insert data inside home section -------------------

    {
      path: "/forms",
      name: "Forms",
      children: [
        {
          path: "/pages/ug-registration",
          name: "UG Registration",
          element: <UgRegistration />,
          route: PrivateRoute,
        },
        {
          path: "/pages/mbbs-student-list",
          name: "MBBS",
          element: <MbbsStudentList />,
          route: PrivateRoute,
        },
        {
          path: "/pages/nursing-student-list",
          name: "NURSING",
          element: <NursingStudentList />,
          route: PrivateRoute,
        },
        {
          path: "/pages/mbbs-Electives",
          name: "MBBSElectives",
          element: <MbbsElectives />,
          route: PrivateRoute,
        },
        {
          path: "/pages/ug-attendance",
          name: "UG Attendance",
          element: <UGAttendance />,
          route: PrivateRoute,
        },
        {
          path: "/pages/pg-attendance",
          name: "PG Attendance",
          element: <PGAttendance />,
          route: PrivateRoute,
        },

        {
          path: "/forms/basic",
          name: "Basic Elements",
          element: <BasicForms />,
          route: PrivateRoute,
        },
        // {
        //   path: "/forms/menubar",
        //   name: "Menubar",
        //   element: <Menubar />,
        //   route: PrivateRoute,
        // },

        {
          path: "/forms/banner",
          name: "Banner",
          element: <Banner />,
          route: PrivateRoute,
        },
        {
          path: "/forms/advanced",
          name: "Form Advanced",
          element: <FormAdvanced />,
          route: PrivateRoute,
        },
        {
          path: "/forms/validation",
          name: "Form Validation",
          element: <FormValidation />,
          route: PrivateRoute,
        },

        {
          path: "/forms/latestinformation",
          name: "Form Latest Information",
          element: <LatestInformation />,
          route: PrivateRoute,
        },

        {
          path: "/forms/internationalsportingevents",
          name: "Form International Sporting Events",
          element: <InternationalSportingEvents />,
          route: PrivateRoute,
        },

        {
          path: "/forms/header",
          name: "Form header",
          element: <Header />,
          route: PrivateRoute,
        },

        {
          path: "/pages/headlink",
          name: "Form Head Link",
          element: <HeadLink />,
          route: PrivateRoute,
        },

        {
          path: "/forms/marquees",
          name: "Form marquees",
          element: <Marquees />,
          route: PrivateRoute,
        },
        {
          path: "/forms/risingstar",
          name: "Form risingstar",
          element: <Risingstar />,
          route: PrivateRoute,
        },
        {
          path: "/forms/footer",
          name: "Form footer",
          element: <FooterSection />,
          route: PrivateRoute,
        },
        {
          path: "/forms/departments",
          name: "Departments",
          element: <Departments />,
          route: PrivateRoute,
        },

        {
          path: "/pages/facultyofmedicine",
          name: "Faculty Of Medicine",
          element: <FacultyOfMedicine />,
          route: PrivateRoute,
        },

        {
          path: "/pages/facultyofNnursing",
          name: "Faculty Of Nursing",
          element: <FacultyOfNursing />,
          route: PrivateRoute,
        },

        {
          path: "/pages/facultyofpharmacy",
          name: "Faculty Of Pharmacy",
          element: <FacultyOfPharmacy />,
          route: PrivateRoute,
        },

        {
          path: "/pages/facultyofparamedicalscience",
          name: "Faculty Of Paramedical Sciences",
          element: <FacultyOfParamedicalScience />,
          route: PrivateRoute,
        },

        {
          path: "/pages/facultyofdentalsciences",
          name: "Faculty Of Dental Sciences",
          element: <FacultyOfDentalSciences />,
          route: PrivateRoute,
        },

        {
          path: "/forms/events",
          name: "Events",
          element: <Events />,
          route: PrivateRoute,
        },

        {
          path: "/forms/news",
          name: "Form news",
          element: <News />,
          route: PrivateRoute,
        },

        {
          path: "/forms/wizard",
          name: "Form Wizard",
          element: <FormWizard />,
          route: PrivateRoute,
        },
        {
          path: "/forms/upload",
          name: "File Upload",
          element: <FileUpload />,
          route: PrivateRoute,
        },
        {
          path: "/forms/editors",
          name: "Editors",
          element: <Editors />,
          route: PrivateRoute,
        },
      ],
    },

    {
      path: "/pages",
      name: "Pages",
      icon: "package",
      header: "Custom",
      children: [
        {
          path: "/pages/employee",
          name: "Employee",
          element: <Employee />,
          route: PrivateRoute,
        },
      ],
    },

    {
      path: "/components/charts",
      name: "Charts",
      element: <Charts />,
      route: PrivateRoute,
    },
    {
      path: "/tables",
      name: "Tables",
      children: [
        {
          path: "/tables/basic",
          name: "Basic",
          element: <BasicTables />,
          route: PrivateRoute,
        },
        {
          path: "/tables/advanced",
          name: "Advanced",
          element: <AdvancedTables />,
          route: PrivateRoute,
        },
      ],
    },
    {
      path: "/maps",
      name: "Maps",
      children: [
        {
          path: "/maps/googlemaps",
          name: "Google Maps",
          element: <GoogleMaps />,
          route: PrivateRoute,
        },
        // /maps/vectorMaps removed: its VectorMap components (src/components/VectorMap/*)
        // are unused CRA-template demo country maps (per the merge review) pulling in
        // jsvectormap subpaths that no longer exist in the current published version,
        // breaking the production build for a route nothing links to.
      ],
    },
  ],
};

// auth
const authRoutes: RoutesProps[] = [
  {
    path: "/auth/login",
    name: "Login",
    element: <Login />,
    route: Route,
  },
  // {
  //   path: "/school/login",
  //   name: "Student Login",
  //   element: <StudentLogin />,
  //   route: Route,
  // },
  {
    path: "/auth/register",
    name: "Register",
    element: <Register />,
    route: Route,
  },
  {
    path: "/auth/confirm",
    name: "Confirm",
    element: <Confirm />,
    route: Route,
  },
  {
    path: "/auth/forget-password",
    name: "Forget Password",
    element: <ForgetPassword />,
    route: Route,
  },
  {
    path: "/auth/lock-screen",
    name: "Lock Screen",
    element: <LockScreen />,
    route: Route,
  },
  {
    path: "/auth/logout",
    name: "Logout",
    element: <Logout />,
    route: Route,
  },
  {
    path: "/auth/reset-password/:token",
    name: "Forgot Password Via Mail",
    element: <ForgotPasswordLink />,
    route: Route,
  },
];

// public routes
const otherPublicRoutes: RoutesProps[] = [
  {
    path: "/home",
    name: "home",
    element: <Landing />,
    route: Route,
  },
  {
    path: "/helpdesk",
    name: "helpdesk",
    element: <HelpDesk />,
    route: Route,
  },
  {
    path: "/crc-list",
    name: "crc-list",
    element: <CRCList />,
    route: Route,
  },
  {
    path: "/coordinator-trainer",
    name: "coordinator-trainer",
    element: <CoordinatorTrainer />,
    route: Route,
  },
  {
    path: "/mbbs",
    name: "helpdesk",
    element: <Mbbsdesc />,
    route: Route,
  },
  {
    path: "/dummy-studentProfile",
    name: "Student Profile",
    element: <DummyStudentProfile />,
    route: Route,
  },
  {
    path: "/viewAttendance",
    name: "View Attendance",
    element: <EcommerceDashboard1 />,
    route: Route,
  },
  {
    path: "/viewAttendance1",
    name: "View Attendance",
    element: <EcommerceDashboard2 />,
    route: Route,
  },

  {
    path: "/attendaceSheet",
    name: "View Attendance",
    element: <AttendaceSheet />,
    route: Route,
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    element: <Maintenance />,
    route: Route,
  },
  {
    path: "/error-404",
    name: "Error - 404",
    element: <Error404 />,
    route: Route,
  },
  {
    path: "/gallery",
    name: "Gallery",
    element: <Gallery />,
    route: Route,
  },
  {
    path: "/error-500",
    name: "Error - 500",
    element: <Error500 />,
    route: Route,
  },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
  let flatRoutes: RoutesProps[] = [];

  routes = routes || [];
  // console.log('routes', routes)
  routes.forEach((item: RoutesProps) => {
    // Group entries (e.g. blockRoutes/districtRoutes/stateRoutes) reuse their
    // own group path as their first child's path and carry no `element` of
    // their own. Pushing them here creates a second <Route> with that exact
    // path but element=undefined, which — tying on path specificity with the
    // real child route — can win the match first and render a blank page.
    // Only leaf routes (real elements) should become actual <Route>s.
    if (item.element) {
      flatRoutes.push(item);
    }

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const authProtectedRoutes = [
  dashboardRoutes,
  districtRoutes,
  blockRoutes,
  stateRoutes,
  ...appRoutes,
  extrapagesRoutes,
  uiRoutes,
];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);

export {
  publicRoutes,
  authProtectedRoutes,
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
};
